<template>
  <div class="account-page">
    <div class="layout">
      <aside class="sidebar">
        <div class="profile-block sk-prof">
          <div class="sk sk-avatar" />
          <div class="sk-text">
            <div class="sk sk-line sk-n" />
            <div class="sk sk-line sk-e" />
          </div>
        </div>
        <div class="sk sk-menu" v-for="i in 4" :key="'m-' + i" />
      </aside>
      <main class="content">
        <div class="sk sk-line sk-t1" />
        <div class="sk sk-line sk-t2" />
        <div class="sk-panel">
          <div class="sk sk-line sk-p-h" />
          <div class="sk-rows">
            <div class="sk sk-field" v-for="j in 6" :key="'f-' + j" />
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
export default { name: "AccountPageSkeleton" };
</script>

<style scoped>
.account-page {
  padding-top: 96px;
  padding-bottom: 40px;
}
.layout {
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 32px;
  align-items: start;
}
@media (max-width: 900px) {
  .layout {
    grid-template-columns: 1fr;
  }
}
.profile-block {
  display: flex;
  gap: 14px;
  margin-bottom: 24px;
}
.sk-avatar {
  width: 56px;
  height: 56px;
  border-radius: 999px;
  flex-shrink: 0;
}
.sk-text {
  flex: 1;
}
.sk-n {
  height: 16px;
  width: 70%;
  margin-bottom: 8px;
}
.sk-e {
  height: 13px;
  width: 90%;
}
.sk-menu {
  height: 40px;
  border-radius: 10px;
  margin-bottom: 10px;
}
.sk-t1 {
  height: 28px;
  width: 220px;
  margin-bottom: 10px;
}
.sk-t2 {
  height: 14px;
  width: 320px;
  margin-bottom: 24px;
}
.sk-panel {
  background: #152338;
  border: 1px solid #1e3352;
  border-radius: 14px;
  padding: 22px;
}
.sk-p-h {
  height: 18px;
  width: 45%;
  margin-bottom: 20px;
}
.sk-rows {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.sk-field {
  height: 48px;
  border-radius: 10px;
}
</style>
